import type { ParameterDimensionDefinitionInOut } from '@festina/configuration-general-types/configuration'

import { ParameterDimensionExpression } from './ParameterDimensionExpression'
import { ParameterDimensionNameCell } from './ParameterDimensionNameCell'
import { ParameterDimensionTypeCell } from './ParameterDimensionTypeCell'

type Props = {
  data: ParameterDimensionDefinitionInOut
  column: number
  row?: number
}

export const ParameterDimensionRowCell = ({ data, column }: Props) => {
  switch (column) {
    case 0:
      return <ParameterDimensionNameCell data={data} />
    case 1:
      return <ParameterDimensionTypeCell data={data} />
    case 2:
      return <ParameterDimensionExpression data={data} isTransparent />
    default:
      throw new Error(
        `Invalid table column. No data available for column ${column}`,
      )
  }
}
